export default "__VITE_ASSET__BhNWaFLC__"